export default __webpack_public_path__ + "static/media/2.e98e2adb.jpg";